import { CardAppType } from 'components/cardApp';
import { CardApp } from 'components/cardApp/CardApp';
import { Wrapper } from 'components/wrapper';
import styles from './CardAppList.module.scss';

export type CardAppListProps = {
  cardAppItems: CardAppType[];
};

export const CardAppList = ({ cardAppItems }: CardAppListProps) => {
  return (
    <Wrapper bgColorTransparent={true} noPaddingTop={true}>
      <div className={styles.container}>
        {cardAppItems.map((cardAppItem, index) => {
          return <CardApp hasWrapper className={styles.cardApp} key={cardAppItem + '-' + index} {...cardAppItem} />;
        })}
      </div>
    </Wrapper>
  );
};
